module.exports = __webpack_public_path__ + "img/qrlogin.1417a665.png";